/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
(function() {
    'use strict';
    var trackingKeys = ['category', 'action', 'label', 'page', 'funnel', 'legacy'];
    var isValid = function(str) {
        return _.isString(str) && !_.isEmpty(str);
    };
    var triggerTracking = function(type, data) {
        Odigeo.trigger('analytics:tracking', {
            type: type,
            data: data,
        });
    };
    var counterMetric = function(key, extraTokens) {
        if ('true' !== Odigeo.Session.get('disableGrafana')) {
            $.ajax({
                url: Odigeo.Settings.getProperty('metricServiceUrlFormatter')('counterMetric/' + key),
                data: JSON.stringify(extraTokens || {}),
                dataType: 'json',
                contentType: 'application/json',
                type: 'POST',
            });
        }
    };

    module.exports = {
        bindEvents: function($page) {
            $page.off('.tracking').on(
                Odigeo.Events.tap + '.tracking', '[data-auto-tracking]',
                _.bind(this.processTrackingHandler, this, _, Odigeo.History.getPageNameFromFragment())
            );
            Odigeo.off('widgetstracking:eventtrack')
                .on('widgetstracking:eventtrack', _.partial(this.processTracking, _, Odigeo.History.getPageNameFromFragment().split('/')[0]));
        },
        trackEvent: function(action, label, page) {
            if (isValid(action) && isValid(label)) {
                this.processTracking({
                    action: action,
                    label: label,
                }, page);
            }
        },
        trackPage: function(page, config) {
            Odigeo.trigger('analytics:tracking', {
                type: 'trackVirtualPage',
                data: {
                    page: page,
                    funnel: _.result(config, 'funnel', true),
                    legacy: _.result(config, 'legacy'),
                    error: _.result(config, 'error'),
                },
            });
        },
        setCustomDimension: function(index, value) {
            Odigeo.trigger('analytics:tracking', {
                type: 'setCustomDimension',
                data: {
                    customDimension: index,
                    value: value,
                },
            });
        },
        processTrackingHandler: function(ev, page) {
            var $elTracking = $(ev.currentTarget);
            var optionsTracking = _.clone($elTracking.data('autoTracking'));

            this.processTracking(optionsTracking, page);
        },
        processTracking: function(optionsTracking, page) {
            var pageToTrack = page || Odigeo.History.getPageNameFromFragment().split('/')[0];
            var dataTracking = _.extend({
                category: pageToTrack,
                page: pageToTrack,
            }, _.pick(optionsTracking, trackingKeys));
            triggerTracking(!_.isUndefined(optionsTracking) && optionsTracking.gaType ? optionsTracking.gaType : 'trackEvent', dataTracking);
        },

        trackEventWithCategory: function(category, action, label) {
            var dataTracking = {
                category: category,
                action: action,
                label: label,
            };
            triggerTracking('trackEvent', dataTracking);
        },

        trackStop: function(key) {
            $.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('stopMetric/' + key));
        },

        startMetric: function(key) {
            Odigeo.Session.set(key, Date.now());
        },

        stopMetric: function(key) {
            var timeEnd = Date.now();
            var timeInit = Odigeo.Session.get(key);
            var disableGrafana = Odigeo.Session.get('disableGrafana');

            Odigeo.Session.remove(key);
            if ('true' !== disableGrafana && !!timeInit) {
                $.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('trackTime'), {
                    key: key,
                    time: timeEnd - timeInit,
                });
            }
        },

        trackEventIfCondition: function(category, action, label, condition) {
            if (condition) {
                this.trackEventWithCategory(category, action, label);
            }
        },

        addCrossDomainIframesTracking: function() {
            var iframes = $('iframe.tracking-cross-domain');
            _.forEach(iframes, function(iFrame) {
                triggerTracking('addCrossDomainIframeTracking', iFrame);
            });
        },

        openExternalLink: function(url, onlyUniversal) {
            var dataTracking = {
                url: url,
                goOutside: true,
                onlyUniversal: onlyUniversal || false,
            };
            triggerTracking('sendToPageBlank', dataTracking);
        },

        trackPromo: function($promo, isClick, index) {
            triggerTracking('trackPromo', {
                promo: {
                    'id': $promo.data('track-id'),
                    'name': $promo.data('track-name'),
                    'creative': $promo.data('track-creative'),
                    'position': $promo.data('track-position'),
                },
                isClick: isClick,
                index: index,
            });
        },

        trackInternalCampaigns: function() {
            var $internalCampaigns = $('.internal-campaign-tracking');
            _.forEach($internalCampaigns, (promo, index) => {
                var $promo = $(promo);
                this.trackPromo($promo, false, index+1);
                $promo.on(Odigeo.Events.tap, _.bind(this.trackPromo, this, $promo, true, index+1));
            });
            triggerTracking('trackPromo', {
                promo: {
                    'id': 'XX',
                    'name': 'XX',
                    'creative': 'XX',
                    'position': 'XX',
                },
                isClick: false,
                index: -1,
            });
        },

        decorateAppTouchpointUrl: function(url) {
            var decoratedUrl = '';
            Odigeo.requireWidget('google-analytics', 'googleanalytics', function(googleanalytics) {
                decoratedUrl = googleanalytics.get('getDecoratedAppTouchpointUrl', url);
            });
            return decoratedUrl;
        },

        counterMetric: counterMetric,

        trackHomeContinuance: function() {
            const metricContinuance = 'HOME_CONTINUANCE';
            counterMetric(metricContinuance, {
                REGISTRY_NAME: 'frontend-html5',
            });
        },

        internalLinkingTypesMap: {
            popcities: 'city',
            popcountries: 'country',
            pophotelslandmarks: 'hotelslandmarks',
            poproutes: 'routes',
            popairlines: 'airlines',
            popdest: 'hotels',
        },
    };
}());
